import React from 'react';
import {Grid} from "@mui/material";

type GroupSummariesCardItemContainerProps = React.ComponentPropsWithoutRef<'div'>;

const GroupSummariesCardItemContainer = (props: GroupSummariesCardItemContainerProps) => {
  return <Grid item xs={12} sm={6} md={4} {...props} />
}

export { GroupSummariesCardItemContainer };
